import React, { useState } from 'react'
import * as PropTypes from 'prop-types'

const MenuItem = props => {
  const [subMenuActive, setSubMenuActive] = useState(false)
  if (!props.show) {
    return null
  }

  return (
    <div key={props.label} className="menu-button" onMouseLeave={handleMouseLeave}>
      <div
        className={`main-menu-button  ${props.isActive ? 'active' : ''} ${subMenuActive ? 'selected' : ''}`}
        onClick={handleMenuClick}
      >
        <div className="icon-menu-item">
          <i className={props.icon} />
        </div>
        <span className="label">{props.label}</span>
      </div>
      {subMenuActive && props.options ? (
        <div className="menu-options-dropdown">
          {props.options.map((submenu, index) => {
            // render submenu item if 'show' property is omitted or explicitly set to true
            return submenu.show === undefined || submenu.show === true ? (
              <div key={index} className="option" onClick={submenu.action}>
                {submenu.label}
              </div>
            ) : null
          })}
        </div>
      ) : null}
    </div>
  )

  function handleMenuClick() {
    if (props.action) {
      props.action()
    }

    if (props.options && props.options.length) {
      setSubMenuActive(true)
    }
  }

  function handleMouseLeave() {
    if (subMenuActive) {
      setSubMenuActive(false)
    }
  }
}

MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  show: PropTypes.bool,
  action: PropTypes.func,
  options: PropTypes.array
}

export default MenuItem
